
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.5 22.8L.602 18.3c-.801-.402-.801-1 0-1.402L4 15.301l6.398 3c.801.398 2.204.398 3 0l6.403-3 3.398 1.597c.801.403.801 1 0 1.403l-9.898 4.5c-.602.3-2 .3-2.801 0zm0 0","fill":"#ff6f3d"}}),_c('path',{attrs:{"d":"M10.5 17.2L.602 12.7c-.801-.4-.801-1 0-1.4L4 9.7l6.5 3c.8.402 2.2.402 3 0l6.5-3 3.398 1.5c.801.402.801 1 0 1.402l-9.898 4.5c-.8.5-2.2.5-3 .097zm0 0","fill":"#95c038"}}),_c('path',{attrs:{"d":"M10.5 11.7L.602 7.2c-.801-.4-.801-1 0-1.4L10.5 1.3c.8-.402 2.2-.402 3 0l9.898 4.5c.801.4.801 1 0 1.4L13.5 11.7c-.8.402-2.2.402-3 0zm0 0","fill":"#5dc0e8"}})])])
          )
        }
      }
    